import { Avatar } from "@mui/material";
import * as S from "./styles";
import { colors } from "@/theme";

export type DealerAvatarProps = {
  children?: React.ReactNode;
  width?: number;
  height?: number;
};

const DealerAvatar: React.FC<DealerAvatarProps> = ({
  children = undefined,
  width = 40,
  height = 40,
}) => {
  return (
    <S.DealerAvatarContainer>
      <Avatar
        sx={{
          width: width,
          height: height,
          backgroundColor: colors.white,
          border: "3px solid black",
        }}
      >
        {children}
      </Avatar>
    </S.DealerAvatarContainer>
  );
};

export default DealerAvatar;
